import { useCallback, useEffect, useState } from "react";
import { useGetActorSummary, useGetActorTasks } from "../../api/UsersApi";
import { AssignmentData, HeaderAssignmentHeader } from "./models";

export const useAssignmentHooks = (domainFilter: "workflow" | "blueprint") => {
  const {
    mutate: getActorTasks,
    data: tasks,
    isLoading: isLoadingActorTasks,
  } = useGetActorTasks();
  const {
    mutate: getActorSummary,
    data: actorSummary,
    isLoading: isLoadingActorSummary,
  } = useGetActorSummary();
  const [updatedAt, setUpdatedAt] = useState(Date.now());

  const loadActorInfo = useCallback(() => {
    getActorTasks();
    getActorSummary();
  }, [getActorTasks, getActorSummary]);

  useEffect(() => {
    loadActorInfo();
  }, [loadActorInfo]);

  useEffect(() => {
    setUpdatedAt(Date.now());
  }, [tasks, actorSummary]);

  let headers: HeaderAssignmentHeader[] = [];

  headers =
    tasks
      ?.filter((task) => task.domain === domainFilter)
      .map((task) => ({
        name: task.display,
        key: task.key,
      })) ?? [];

  const data: AssignmentData[] =
    actorSummary?.map((actor) => ({
      actor_uuid: actor.actor_uuid,
      email: actor.email,
      tasks: [
        ...(actor.tasks.workflow?.WorkflowStepConfigs.map((task) => ({
          key: task,
        })) ?? []),
        ...(actor.tasks.blueprint?.Blueprints.map((task) => ({
          key: task,
        })) ?? []),
      ],
      lastActive: actor.last_action_at,
      lastTask: actor.last_action,
    })) ?? [];

  const isLoading = isLoadingActorTasks || isLoadingActorSummary;
  return { isLoading, headers, data, loadActorInfo, updatedAt };
};
